import './index.css'
import { fmt } from '../../lib/format'
import type { MobileHeroProps } from '../../types'

export default function MobileHero({ realizedIncome, realizedExpense, realizedBalance, realizedPct }: MobileHeroProps) {
  const neg = realizedBalance < 0
  return (
    <div className="bcm-hero bc-mobile-only" data-tour="mobile-hero">
      <div className="bcm-hero__lbl">Saldo do mês</div>
      <div className={'bcm-hero__val' + (neg ? ' is-neg' : '')}>
        {neg ? '−' : '+'} R$ {fmt(Math.abs(realizedBalance))}
      </div>
      <div className="bcm-hero__split">
        <div className="bcm-hero__cell">
          <span className="bcm-hero__cell-lbl">Receitas</span>
          <span className="bcm-hero__cell-val is-in">R$ {fmt(realizedIncome)}</span>
        </div>
        <div className="bcm-hero__cell">
          <span className="bcm-hero__cell-lbl">Despesas</span>
          <span className="bcm-hero__cell-val is-out">R$ {fmt(realizedExpense)}</span>
        </div>
      </div>
      <div className="bcm-hero__progress">
        <div className="bcm-hero__progress-row">
          <span>{realizedPct}% da renda gasta</span>
        </div>
        <div className="bcm-hero__track">
          <div
            className={'bcm-hero__fill ' + (realizedPct > 100 ? 'is-warn' : 'is-ok')}
            style={{ width: Math.min(realizedPct, 100) + '%' }}
          />
        </div>
      </div>
    </div>
  )
}
